/**
 * Iter 101 — Brand mark with a tight superscript copyright glyph.
 *
 * Renders "Physiogenic©" with the © tucked snug against the trailing "c" —
 * slightly above the baseline + minimal lateral gap. Mimics a textbook
 * trademark presentation.
 */
import React from 'react';

export function BrandName({ className = '' }) {
  return (
    <span className={className} data-testid="brand-name">
      Physiogenic<sup style={{ fontSize: '0.42em', verticalAlign: 'super', marginLeft: '-0.05em', lineHeight: 1 }} className="select-none font-normal">©</sup>
    </span>
  );
}

export default BrandName;
